<div class="p-2 position-relative">
    <div class="title-obs p-2">
        <div class="d-flex justify-content-between align-items-center">
            <div class="flex-grow-1 me-2">
                <h4 *ngIf="!isEditObs" class="mb-0 title-obs-text">
                    Observații:
                    <span class="observatii-text">{{ form.get('observatii')?.value || 'N/A' }}</span>
                </h4>
                <!-- <h4 *ngIf="isEditObs" class="mb-0 title-obs-text">Editare Observații</h4> -->
            </div>
            <!-- <div class="d-flex align-items-center flex-shrink-0">
                <button *ngIf="!isEditObs && editableObs" type="button" class="btn btn-sm btn-warning ms-1"
                    (click)="editObs()" title="Editare">
                    <i class="fa-solid fa-pencil"></i>
                </button>
                <button *ngIf="isEditObs && editableObs" type="button" class="btn btn-sm btn-success ms-1"
                    (click)="saveObs()" title="Salvare">
                    <i class="fa-solid fa-check"></i>
                </button>
                <button *ngIf="isEditObs" type="button" class="btn btn-sm btn-danger ms-3" (click)="cancelEditObs()"
                    title="Anulare">
                    <i class="fa-solid fa-close"></i>
                </button>
            </div> -->
        </div>
    </div>

    <!-- <form *ngIf="isEditObs" [formGroup]="form" class="my-2">
        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Observații</mat-label>
                    <textarea matInput formControlName="observatii" name="observatii"
                        placeholder="Introduceți observațiile aici..."></textarea>
                </mat-form-field>
            </div>
        </div>
    </form> -->

    <div class="title p-2">
        <div class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0 text-center">Istoric Relație</h4>
            <div class="d-flex align-items-center">
                <button class="btn btn-small btn-info edit-btn" title="Descarcă" (click)="downloadChanges()">
                    <i class="fa fa-download fa-sm"></i>
                    Print
                </button>
            </div>
        </div>
    </div>

    <div class="container p-2">
        <table datatable [dtOptions]="dtOptions" class="row-border hover w-100"></table>
    </div>

    <div class="d-flex justify-content-between">
        <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
            {{ helper.dialogConfig.buttonLabels.close }}
        </button>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>